if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.handleKeyboardScroll = this.handleKeyboardScroll.bind(this);
      }

      hide() {
        super.hide();
        this.removeKeyboardScrollListener();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.addKeyboardScrollListener();
      }

      addKeyboardScrollListener() {
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.addEventListener('keydown', this.handleKeyboardScroll);
          // Ensure the container can receive focus
          if (!container.hasAttribute('tabindex')) {
            container.setAttribute('tabindex', '0');
          }
          // Focus the container so keyboard events work immediately
          setTimeout(() => container.focus(), 100);
        }
      }

      removeKeyboardScrollListener() {
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.removeEventListener('keydown', this.handleKeyboardScroll);
        }
      }

      handleKeyboardScroll(event) {
        const container = event.currentTarget;
        const scrollAmount = 50; // pixels to scroll per key press
        const pageScrollAmount = container.clientWidth * 0.8; // 80% of visible width for page up/down
        
        let handled = false;

        switch(event.key) {
          case 'ArrowLeft':
            container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
            handled = true;
            break;
          case 'ArrowRight':
            container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
            handled = true;
            break;
          case 'ArrowUp':
            container.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
            handled = true;
            break;
          case 'ArrowDown':
            container.scrollBy({ top: scrollAmount, behavior: 'smooth' });
            handled = true;
            break;
          case 'PageUp':
            container.scrollBy({ left: -pageScrollAmount, behavior: 'smooth' });
            handled = true;
            break;
          case 'PageDown':
            container.scrollBy({ left: pageScrollAmount, behavior: 'smooth' });
            handled = true;
            break;
          case 'Home':
            container.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            handled = true;
            break;
          case 'End':
            container.scrollTo({ left: container.scrollWidth, top: 0, behavior: 'smooth' });
            handled = true;
            break;
        }

        if (handled) {
          event.preventDefault();
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
